import { useEffect } from 'react';
import { AuthenticationResult, Configuration, EventType, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

import { msalConfig } from './msal.config';

export interface AppMsalProviderProps {
  config: Configuration;
  children: React.ReactNode;
}

export const AppMsalProvider = ({ children, config }: AppMsalProviderProps) => {
  const msalInstance = new PublicClientApplication({ ...msalConfig, ...config });

  const accounts = msalInstance.getAllAccounts();

  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  useEffect(() => {
    const callbackId = msalInstance.addEventCallback((event) => {
      if (event.eventType !== EventType.LOGIN_SUCCESS) return;

      const payload = event.payload as AuthenticationResult;
      if (!payload.account) return;

      msalInstance.setActiveAccount(payload.account);
    });

    return () => {
      if (callbackId) {
        msalInstance.removeEventCallback(callbackId);
      }
    };
  });

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};
